<template>
  <textarea v-if="isTextArea" :placeholder="placeholder" @input="handleInput" maxlength="5000" class="textInputField textArea" :id="id" />
  <input v-else type="text" class="textInputField" @input="handleInput" maxlength="256" :placeholder="placeholder" :value="modelValue" />
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String
    },

    isTextArea: {
      type: Boolean,
      default: false
    },

    modelValue: {
      type: String
    },

    id: {
      type: String,
      default: ''
    }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      content: this.modelValue
    };
  },

  methods: {
    handleInput(e) {
      this.$emit('update:modelValue', e.target.value);
    }
  }
};
</script>

<style scoped>
.textInputField {
  height: 30px;
  width: 100%;
  padding: 8px 12px;
  line-height: 1.4;
  color: white;
  background-color: rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: border-color 200ms ease;
  font-family:monospace;
}

.textInputField:hover {
  border-color: rgba(255, 255, 255, 0.5);
}

.textInputField:focus {
  outline: none;
  border-width: 2px;
  border-color: rgba(255, 255, 255, 1);
}

.textArea {
  height: auto !important;
}
</style>
